import * as m from 'motion/react-m'

import { EASE_OUT } from '../../../util/easingRules'

import styles from './EmptyStateWrapper.module.css'

import type { JSX } from 'react'

type EmptyStateWrapperProps = {
  children: React.ReactNode
  shouldAnimate?: boolean
}

/**
 * Expands an inbox empty state into place. `shouldAnimate` is for the state
 * arriving because the user just resolved the last item; it defaults off
 * because a state that was already on screen at load has nothing to
 * transition from. The exit transition needs an `AnimatePresence` ancestor.
 */
export const EmptyStateWrapper = ({
  children,
  shouldAnimate = false,
}: EmptyStateWrapperProps): JSX.Element => {
  return (
    <m.div
      initial={shouldAnimate ? { opacity: 0, height: 0 } : false}
      animate={{ opacity: 1, height: 'auto' }}
      exit={{ opacity: 0, height: 0 }}
      transition={{
        duration: 0.4,
        ease: EASE_OUT.quad,
      }}
      className={styles.container}
    >
      {children}
    </m.div>
  )
}
